import { createIcon } from "@chakra-ui/icons";

const LogIn01 = createIcon({
  displayName: "LogIn01",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M15 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11985 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H15M10 7L15 12M15 12L10 17M15 12L3 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      key="xd5M"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default LogIn01;
